import {
  getMicAudioConstraints,
  requiresMicUserGesture,
} from "./deviceDetection";

let persistentStream = null;
let acquisitionPromise = null;

export const acquireMicStream = async (constraints = getMicAudioConstraints()) => {
  if (
    persistentStream &&
    persistentStream.getTracks().some((track) => track.readyState === "live")
  ) {
    return persistentStream;
  }

  if (acquisitionPromise) {
    return acquisitionPromise;
  }

  acquisitionPromise = navigator.mediaDevices
    .getUserMedia({ audio: constraints })
    .then((stream) => {
      persistentStream = stream;
      acquisitionPromise = null;
      return stream;
    })
    .catch((error) => {
      acquisitionPromise = null;
      throw error;
    });

  return acquisitionPromise;
};

export const getPersistentMicStream = () => {
  if (
    persistentStream &&
    persistentStream.getTracks().some((track) => track.readyState === "live")
  ) {
    return persistentStream;
  }
  return null;
};

export const releaseMicStream = () => {
  if (persistentStream) {
    persistentStream.getTracks().forEach((track) => track.stop());
    persistentStream = null;
  }
  acquisitionPromise = null;
};

/**
 * Call synchronously inside a click/tap handler before any await.
 * Keeps the mic permission alive for auto-enable after AI audio on iOS.
 */
export const prewarmMicForGesture = () => {
  if (!requiresMicUserGesture()) return;

  acquireMicStream(getMicAudioConstraints()).catch((error) => {
    console.warn("Mic prewarm failed:", error);
  });
};
